import React from "react";
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function Clients() {

  // useEffect(()=>{
  //     document.title = 'Elixir | Our Clients';
  //   }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Clients</span></h1>
                <h4>“We love the Simplicity.”</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="aboutPages-box2">
                  <img src={require('../assets/img/clients-page-banner-1.jpg')} className="img-fluid" alt="elixir" />
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="innerPages-box3">
                <div className="logoPart">
                  <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>
                  <hr />
                  <p><span>Mail:</span> <a href="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                  <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>         
                </div>
              </div>
            </Col>
          </Row>
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">
                <div className="contactMap-text">
                  <h3>Our Clients</h3>
                  <p>At Elixir & AR Graphics, we take pride in building strong, long-lasting relationships with our clients. Our clientele spans a wide spectrum of industries, including corporate enterprises, government organizations, SMEs, startups, and international brands.</p>
                  <p>We partner with organizations that value quality, innovation, and reliability, delivering tailored solutions that meet their unique business needs.</p>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="clientPages-box5">
                <Row>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-1.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-2.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-3.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-4.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-5.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-6.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-7.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-8.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-9.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-10.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-11.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-12.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-13.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-14.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-15.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-16.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-17.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-18.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-19.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-20.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-21.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-22.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-23.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-24.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-25.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-26.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-27.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-28.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-29.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-30.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-31.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-32.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                  <Col lg={2} md={3} xs={6}>
                    <img src={require('../assets/img/client/client-logo-33.jpg')} className="img-fluid" alt="elixir" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Clients;
